@if (!hideFooter) {
  <div class="app-footer">
    <div class="d-flex flex-row m-3 gap-3 flex-grow-1 justify-content-start">
      @if (footerLinks.siemensDigitalProductPassport) {
        <div>
          <a
            [href]="'links.siemens_battery_passport_link' | translate"
            class="link"
            id="footerPassportLink"
            rel="noopener"
            target="_blank"
            >{{ 'links.siemens_battery_passport_text' | translate }}</a
          >
        </div>
      } @if (footerLinks.aboutBatteryPassEU) {
        <div>
          <a
            [href]="'links.battery_pass_eu_link' | translate"
            class="link"
            id="footerBatteryPassEuLink"
            rel="noopener"
            target="_blank"
            >{{ 'links.battery_pass_eu_text' | translate }}</a
          >
        </div>
      } @if (footerLinks.teamcenterPCM) {
        <div>
          <a
            [href]="'links.tcpcm_link' | translate"
            class="link"
            id="footerTcpcmLink"
            rel="noopener"
            target="_blank"
            >{{ 'links.tcpcm_text' | translate }}</a
          >
        </div>
      } @if (footerLinks.catenaX) {
        <div>
          <a
            [href]="'links.catena_x_link' | translate"
            class="link"
            id="footerCatenaXLink"
            rel="noopener"
            target="_blank"
            >{{ 'links.catena_x_text' | translate }}</a
          >
        </div>
      }
    </div>
    <div class="m-3">
      <ix-typography color="soft" format="body" id="footerVersion"
        >{{ 'general.version' | translate: {version} }} &nbsp; &nbsp; {{
        'general.copyright' | translate: {year} }}
      </ix-typography>
    </div>
  </div>
}
